import { GqlError } from '@amzn/amp-gql'

type FormattedError = GqlError['errors'][number]

function isRateLimitException(error: FormattedError): boolean {
    const type = (error.extensions?.payload as { __type?: unknown } | undefined)?.__type
    return typeof type === 'string' && type.includes('RateLimitExceededException')
}

/**
 * CloudQueue rate limiting: the gateway answers 200 OK with an error whose
 * `extensions.payload.__type` names `RateLimitExceededException`, and nulls the
 * connection it could not resolve.
 */
export function isRateLimitedGqlError(err: unknown): err is GqlError {
    return err instanceof GqlError && err.errors.some(isRateLimitException)
}

export function isNextPageRateLimit(error: FormattedError): boolean {
    const [root, queue, next] = error.path ?? []
    return (
        isRateLimitException(error) &&
        root === 'createQueue' &&
        queue === 'queue' &&
        next === 'next'
    )
}

/** True when there are errors and every one is a rate limit on createQueue's `next` page. */
export function isRateLimitOnlyOnNext(errors: readonly FormattedError[]): boolean {
    return errors.length > 0 && errors.every(isNextPageRateLimit)
}
